import { useState } from 'react';
import _ from 'underscore';

interface FilterOptions {
  name: string;
  value: string | number;
  label: string;
}

interface CurrentFilters {
  [key: string]: string | number;
}

export function useTableFilters() {
  const [currentFilters, setCurrentFilters] = useState<CurrentFilters>({});

  // Only call this function when doing client-side filtering.
  // Server-side filtering should be done by passing parameters
  // to your AJAX fetch.
  const applyFilters = (results: any[]) => {
    let visibleResults = results;

    _.each(currentFilters, (value, fieldName) => {
      if (value) {
        const filterCriteria: any = {};
        filterCriteria[fieldName] = value;
        visibleResults = _.where(visibleResults, filterCriteria);
      }
    });
    return visibleResults;
  };

  const filterByField = (fieldName: string, value: string | number, callback?: () => void) => {
    // Set the filter state.
    setCurrentFilters(prevFilters => {
      const newFilters = { ...prevFilters, [fieldName]: value };
      // Call callback after state update if provided
      if (callback) {
        // Use setTimeout to ensure callback runs after state update
        setTimeout(callback, 0);
      }
      return newFilters;
    });
  };

  // Abstract helper for the other populate functions
  const getFilterOptions = (
    results: any[],
    nameField: string,
    valueField: string,
    allOptionName: string
  ): FilterOptions[] => {
    // Grab and uniq all options based on the value (classroom ID).
    const allNames = _.chain(results)
      .map(result => ({
        name: result[nameField],
        value: result[valueField],
        label: result[nameField]
      }))
      .uniq(false, (option: FilterOptions) => option.value)
      .reject((option: FilterOptions) => option.value === null)
      .value();
    allNames.unshift({ name: allOptionName, value: '', label: allOptionName });
    return allNames;
  };

  return {
    currentFilters,
    setCurrentFilters,
    applyFilters,
    filterByField,
    getFilterOptions
  };
}
